import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
export default function HeroSection() {

    return (
        <>
            <div className="hero">
                <h1>Welcome to INIFITS</h1>
                <p>Your one-stop shop for all things fashion.</p>
                <Link to='/Products' className='Link' style={{ textDecoration: 'none', color: 'black' }}>
                Explore
                </Link>
            </div>
        </>
    )
}